const sortDatesDesc = function (a, b) {
  if (!b) return 1;
  if (!a) return 1;

  return b.valueOf() - a.valueOf();
};

export default sortDatesDesc;
